export enum NavigationToQuizQ {
    Login = "login",
    Website = "website",
    RedeemSuccess = "redeem-success",
    NoPurchase = "no-purchase",
    PlatformDashboard = "platform",
    PlatformPlan = "platform-plan",
    PlatformExperts = "platform-experts",
}